import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('div', {
    staticClass: "mt-10",
    staticStyle: {
      "max-width": "1200px",
      "margin": "0 auto"
    }
  }, [_c('tip')], 1), _c('div', {
    staticClass: " mb-20 ovh feedback-page"
  }, [_c('div', {
    staticClass: "feedback-page__main-cont",
    class: {
      unack: _vm.isUnackFlag
    }
  }, [_c('a-tabs', {
    class: {
      float: _vm.defaultRoute === '/help/feedback/list'
    },
    on: {
      "change": _vm.handleTabChange
    },
    model: {
      value: _vm.defaultRoute,
      callback: function ($$v) {
        _vm.defaultRoute = $$v;
      },
      expression: "defaultRoute"
    }
  }, [_c('a-tab-pane', {
    key: "/help/feedback/add",
    attrs: {
      "fbu-analyse-name": $t("\u610F\u89C1\u53CD\u9988"),
      "data-permission": "help_feedback_add_feedback",
      "id": "help_feedback_add_feedback",
      "tab": _vm.defaultRoute === '/help/feedback/add' ? _vm.t('意见反馈') : _vm.t('提交新的反馈')
    }
  }), _c('a-tab-pane', {
    key: "/help/feedback/list",
    attrs: {
      "fbu-analyse-name": $t("\u6211\u7684\u53CD\u9988\u5386\u53F2"),
      "data-permission": "help_feedback_add_my",
      "id": "help_feedback_add_my",
      "tab": _vm.defaultRoute === '/help/feedback/add' ? _vm.t('我的反馈历史') : _vm.t('我的反馈')
    }
  })], 1), _vm.defaultRoute === '/help/feedback/list' ? _c('div', {
    staticClass: "feedback-page__main-line"
  }) : _vm._e(), _c('router-view', {
    attrs: {
      "keep-alive": ""
    },
    on: {
      "acked": _vm.ackCallback,
      "tabChange": _vm.tabChangeFeedback
    }
  })], 1)])]);
};

var staticRenderFns = [];
export { render, staticRenderFns };